<card-expanding
  [formGroup]="form"
  [valid]="productValidity.getCardStatusValidType(cardSection)"
  [expanded]="isExpanded"
  (onExpand)="saveLocalExpandedValue($event)"
>
  <span header-title>{{ title | translate}}</span>

  <div header-actions *requiredRights="[UserAction.ManageProducts]">
    <ng-container *ngIf="isOwnProduct">
      <locked-info *ngIf="!edit && locked" [locked]="locked"></locked-info>
      <ng-container *ngIf="!edit && !locked">
        <lxm-button
          type="beige"
          icon="edit"
          title="action.edit"
          (click)="toggleEdit()"
        ></lxm-button>
      </ng-container>
      <ng-container *ngIf="edit">
        <lxm-button
          type="grey"
          icon="back"
          label="action.cancel"
          (click)="toggleEdit()"
        >
        </lxm-button>
        <lxm-button
          type="beige"
          icon="save"
          label="action.save"
          [loading]="saveLoading"
          (click)="save()"
          buttonType="submit"
        ></lxm-button>
      </ng-container>
    </ng-container>
  </div>

  <div body>
    <div class="grid w-full grid-cols-1 gap-4 xl:grid-cols-2">
      <div class="flex flex-col">
        <form-field
          label="cards.products.product_electronics.label.is_electronics_device"
          description="cards.products.product_electronics.label_description.is_electronics_device"
          [readonly]="!edit"
        >
          <slide-toggle
            toggle
            for="isElectronicsDevice"
            [readonly]="!edit"
          ></slide-toggle>
          <validation-errors for="isElectronicsDevice"></validation-errors>
        </form-field>

        <form-field
          label="cards.products.product_electronics.label.has_integrated_battery"
          description="cards.products.product_electronics.label_description.has_integrated_battery"
          [readonly]="!edit"
          [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.IntegratedBatteryWeight, form.get('hasIntegratedBattery').value)"
        >
          <slide-toggle
            toggle
            for="hasIntegratedBattery"
            [readonly]="!edit"
          ></slide-toggle>
          <validation-errors for="hasIntegratedBattery"></validation-errors>
        </form-field>
      </div>

      <div class="flex flex-col">
        <form-field
          label="cards.products.product_electronics.label.battery_type"
          description="cards.products.product_electronics.label_description.battery_type"
          [readonly]="!edit"
          for="batteryTypeId"
          [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.BatteryType, form.get('batteryTypeId').value)"
        >
          <lxm-select
            select
            class="w100p"
            [options]="batteryTypeOptions"
            for="batteryTypeId"
            value="id"
            labelField="translatedValue"
            [isTranslated]="true"
            [sortByLabel]="true"
          ></lxm-select>
          <validation-errors for="batteryType"></validation-errors>
        </form-field>

        <ng-container *ngIf="form.get('hasIntegratedBattery').value">
          <form-field
            for="integratedBatteryWeight"
            label="cards.products.product_electronics.label.integrated_battery_weight"
            description="cards.products.product_electronics.label_description.integrated_battery_weight"
            [readonly]="!edit"
            type="input-text"
            [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.IntegratedBatteryWeight, form.get('integratedBatteryWeight').value)"
          >
            <validation-errors
              for="integratedBatteryWeight"
            ></validation-errors>
          </form-field>
        </ng-container>
      </div>
    </div>
  </div>
</card-expanding>
